import React, { useState } from 'react';

import { Popover, ArrowContainer } from 'react-tiny-popover';
import ReactHtmlParser from 'react-html-parser';
import styles from './Popover.css';

function MagPopover({ title, definition }) {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  return (
    <Popover
      containerClassName={styles.magPopoverContainer}
      isOpen={isPopoverOpen}
      positions={['right', 'bottom', 'left']}
      padding={10}
      style={{ zIndex: 99999 }}
      content={({ position, childRect, popoverRect }) => (
        <ArrowContainer
          position={position}
          childRect={childRect}
          popoverRect={popoverRect}
          arrowColor='black'
          arrowSize={8}
        >
          <div className={styles.container}>
            <div className={styles.containerTitle}>{title}</div>
            <div className={styles.containerBody}>
              {ReactHtmlParser(definition)}
            </div>
          </div>
        </ArrowContainer>
      )}
    >
      <span
        style={{ display: definition && definition !== '' ? 'block' : 'none' }}
        className={styles.toggle + ' mag-popover'}
        onMouseEnter={() => setIsPopoverOpen(true)}
        onMouseLeave={() => setIsPopoverOpen(false)}
      >
        <i className='fas fa-info-circle' />
      </span>
    </Popover>
  );
}

export default MagPopover;
